import { render, staticRenderFns } from "./MagicLinkForm.vue?vue&type=template&id=13040f4c"
import script from "./MagicLinkForm.vue?vue&type=script&lang=js"
export * from "./MagicLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports